import React, { Component, PropTypes } from 'react';

let didTraqliScriptLoad = false;

class Traqli extends Component {
	static propTypes = {
    traqliClientId: PropTypes.number.isRequired
  }

	componentDidMount() {
		const { traqliClientId } = this.props;

		if (!didTraqliScriptLoad) {
			const e = document.createElement("script");
			e.setAttribute("id", "tqflexsdksel");
			e.setAttribute("fusionId", traqliClientId);
			e.type = "text/javascript";
			e.src = "//api.traq.li/public/sdk/v03/sdk.js";
			e.async = true;
			document.getElementById("traqli").appendChild(e);
			didTraqliScriptLoad = true;
		}
	}

	render() {
		return (
      <div id="traqli" />
		);
	}
}

export default Traqli;



// WEBPACK FOOTER //
// ./app/components/custom/heartland/thirdParty/Traqli.js